/**
 * Authentication utilities for the portal platform
 *
 * Provides centralized auth token retrieval for API requests.
 */

import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Get the Cognito ID token for authenticated API requests.
 *
 * API Gateway Cognito User Pool authorizers require the ID token, not access token.
 * The ID token contains the 'aud' (audience) claim that the authorizer validates.
 *
 * @returns The ID token string or null if user is not authenticated
 *
 * @example
 * const idToken = await getIdToken();
 * if (idToken) {
 *   headers['Authorization'] = `Bearer ${idToken}`;
 * }
 */
export async function getIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    return idToken || null;
  } catch {
    // User is not authenticated
    return null;
  }
}
